module.exports = __webpack_public_path__ + "img/ringcurtain.fcf742b5.png";